import {requestJson} from '@/ui/services/api.ts';
import {CharacterRosterEntryDTO, CharacterRosterEntrySchema} from '@hexcrawl/shared-utils';
import {z} from 'zod';

export const lobbyService = {
  getRoster(): Promise<CharacterRosterEntryDTO[]> {
    return requestJson<CharacterRosterEntryDTO[]>({
      url: '/character/roster',
      method: 'GET',
      schema: z.array(CharacterRosterEntrySchema),
    });
  },
};
